module.exports = __webpack_public_path__ + "static/media/ny-che-big.47ad8ef2.png";